<template>
  <div v-if="!error">
    <div :class="$style.form">
      <vs-input class="w-full" label="Сумма" v-model="amount" v-currency />
      <elsa-v-datepicker
        class="w-full ml-4"
        label="Месяц назначения"
        v-model="month"
        view-format="MM.yyyy"
        :datepicker-props="{minimumView: 'month'}"
      />
    </div>

    <div :class="$style.link">
      <template v-if="link">
        <div><a :href="link" target="_blank">{{ link }}</a></div>
        <vs-button class="mt-2" @click="onCopy">Скопировать</vs-button>
      </template>
      <div v-else class="text-center italic">Введите сумму и месяц назначения</div>
    </div>
  </div>
  <div v-else :class="$style.error">{{error}}</div>
</template>

<script>
import stringify  from 'qs/lib/stringify';
import copy       from 'copy-to-clipboard';
import formatDate from "@/client/helpers/formatDate";

const { VUE_APP_AGENCY_PERCENT } = process.env;

export default {
  name:  "GeneratePaymentLinkPopup",
  props: ['apartmentId', 'buildingId'],
  data() {
    return {
      error:       null,
      apartment:   null,
      legalEntity: null,
      amount:      '',
      month:       null,
      linkLoading: false,
      link:        null,
      paymentInfo: null,
    };
  },
  computed: {
    building() {
      return this.$store.getters['appUser/houses'].find(house => house.id === this.buildingId);
    },
  },
  methods:  {
    onCopy() {
      copy(this.link);
      this.$vs.notify({ color: 'success', text: 'Ссылка скопирована' });
    },

    loadApartment() {
      this.$http.get(`/building/${this.buildingId}/apartment/${this.apartmentId}`, {
        params: { buildings_id: this.buildingId },
      }).then(( { data } ) => {
        this.apartment = data;
        this.updateLink();
      });
    },

    loadLegalEntity() {
      const { legal_entities_id } = this.building;
      this.$http.get('lentities', { params: { id: legal_entities_id } }).then(( { data } ) => {
        this.legalEntity = data;
        this.updateLink();
      });
    },

    loadPaymentInfo() {
      this.$http.get('app/acquiring', { params: { buildings_id: this.buildingId, channel: 'communal' } }).then(
        ( { data } ) => {
          this.paymentInfo = data;
          this.updateLink();
        },
        ( e ) => {
          this.error = 'Оплата не доступна';
        },
      );
    },

    updateLink() {
      const { amount, month, apartment, legalEntity, paymentInfo } = this;
      if (!amount || !month || !apartment || !legalEntity) return this.link = '';

      // const { publicid } = building;
      const { account_number } = apartment;
      const { vat } = legalEntity;

      let commission = +VUE_APP_AGENCY_PERCENT;
      if (paymentInfo && typeof paymentInfo.parameters.commission === 'number') {
        commission = 1 - paymentInfo.parameters.commission;
      }

      const query = {
        account_number: account_number,
        month:          formatDate(month, 'yyyy-MM'),
        amount:         (+amount / commission).toFixed(2),
        // public_id:      publicid,
        vat,
        source:  'uc',
        channel: 'communal',
      };

      this.$http.get(`account/payment`, { params: query }).then(( { data } ) => {
        this.link = `${document.location.origin}/pay.html?${stringify({ ...query, id: data.id })}`;
      });

    },
  },
  mounted() {
    this.loadApartment();
    this.loadLegalEntity();
    this.loadPaymentInfo();
  },
  watch: {
    amount() {
      this.updateLink();
    },
    month() {
      this.updateLink();
    },
  },
};
</script>

<style lang="scss" module>
.form {
  display: flex;
  margin-top: 1em;
}

.input {
  flex: 1;
}

.button {
  flex-shrink: 0;
  margin-left: 1em;
  margin-top: 21px;
}

.link {
  margin-top: 1em;
  word-break: break-all;
  padding: 1em;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 5px;
}

.error {
  padding: 1em;
  text-align: center;
  color: color(danger);
  font-style: italic;
}

</style>
